/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react';
import { Spin, Card, Form, Select, Input, Checkbox } from 'antd';
import SideNav from '../company-settings/side-nav/component';
import { getPreferenceFromAccount, RootState } from '@share/utils';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import { handlePreferences, IAccountSettingState } from '@store/slices';
import {
  CANCEL_PENALTY_LOGIC_FIELD_KEY,
  DEFAULT_CURRENCY_FIELD_KEY,
  DEFAULT_LANGUAGE_FIELD_KEY,
  DISABLE_OPEN_IN_A_NEW_TAB_FIELD_KEY,
  DISPLAY_EMAIL_FIELD_KEY,
  EMAIL_SUBJECT_CONFIRMED_FIELD_KEY,
  EMAIL_SUBJECT_FIELD_KEY,
  ENABLE_TWO_FACTOR_AUTH_FIELD_KEY,
  GOOGLE_ANALITYCS_CODE_FIELD_KEY,
  IAccount,
  IAccountPreference,
  LEAD_TIME_FIELD_KEY,
  LOGOUT_FIELD_KEY,
  REPLY_EMAIL_FIELD_KEY,
  SEARCH_TYPE_FIELD_KEY,
  TRAVEL_STATEMENT_DESCRIPTOR_FIELD_KEY,
} from '@share/common-types';
import { getAllCurrencies, ILoginState } from '@share/store/slices';

import { Col, Row } from 'react-bootstrap';
import { BlueButton } from '@share/components';
import { FormattedMessage, useIntl } from 'react-intl';
import { SELECTED_LANGUAGE_LABEL } from '@share/constants';

import './style.scss';

interface IMapStateToProps {
  loginStore: ILoginState;
  accountSettingStore: IAccountSettingState;
}

interface IMapDispatchToProps {
  handlePreferences: (
    account: IAccount,
    preferences: IAccountPreference[],
    formData: FormData,
  ) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps { }

interface FieldData {
  name: string[];
  value?: any;
}

interface CurrencyData {
  code: string;
  symbol: string;
}

function CompanyPreferencesComponent(props: IProps) {
  const [fields, setFields] = useState<FieldData[]>([]);
  
  const { loading } = props.accountSettingStore;
  const { account } = props.loginStore;
  const {currencies} = useSelector((state: RootState) => state.currencyStore);
  const dispatch = useDispatch();
  const intl = useIntl();
  useEffect(() => {
    setFields([
      {
        name: [DEFAULT_LANGUAGE_FIELD_KEY],
        value: getPreferenceFromAccount(props.loginStore.account, DEFAULT_LANGUAGE_FIELD_KEY),
      },
      {
        name: [DEFAULT_CURRENCY_FIELD_KEY],
        value: getPreferenceFromAccount(props.loginStore.account, DEFAULT_CURRENCY_FIELD_KEY),
      },
      {
        name: [EMAIL_SUBJECT_CONFIRMED_FIELD_KEY],
        value: getPreferenceFromAccount(
          props.loginStore.account,
          EMAIL_SUBJECT_CONFIRMED_FIELD_KEY,
        ),
      },
      {
        name: [SEARCH_TYPE_FIELD_KEY],
        value: JSON.parse(
          getPreferenceFromAccount(props.loginStore.account, SEARCH_TYPE_FIELD_KEY),
        ),
      },
      {
        name: [GOOGLE_ANALITYCS_CODE_FIELD_KEY],
        value: JSON.parse(
          getPreferenceFromAccount(props.loginStore.account, GOOGLE_ANALITYCS_CODE_FIELD_KEY),
        ),
      },
      {
        name: [TRAVEL_STATEMENT_DESCRIPTOR_FIELD_KEY],
        value: JSON.parse(
          getPreferenceFromAccount(props.loginStore.account, TRAVEL_STATEMENT_DESCRIPTOR_FIELD_KEY),
        ),
      },
      {
        name: [EMAIL_SUBJECT_FIELD_KEY],
        value: getPreferenceFromAccount(props.loginStore.account, EMAIL_SUBJECT_FIELD_KEY),
      },
      {
        name: [REPLY_EMAIL_FIELD_KEY],
        value: getPreferenceFromAccount(props.loginStore.account, REPLY_EMAIL_FIELD_KEY),
      },
      {
        name: [DISPLAY_EMAIL_FIELD_KEY],
        value: getPreferenceFromAccount(props.loginStore.account, DISPLAY_EMAIL_FIELD_KEY),
      },
      {
        name: [DISABLE_OPEN_IN_A_NEW_TAB_FIELD_KEY],
        value: JSON.parse(
          getPreferenceFromAccount(props.loginStore.account, DISABLE_OPEN_IN_A_NEW_TAB_FIELD_KEY),
        ),
      },
      {
        name: [LEAD_TIME_FIELD_KEY],
        value: getPreferenceFromAccount(props.loginStore.account, LEAD_TIME_FIELD_KEY),
      },
      {
        name: [CANCEL_PENALTY_LOGIC_FIELD_KEY],
        value: JSON.parse(
          getPreferenceFromAccount(props.loginStore.account, CANCEL_PENALTY_LOGIC_FIELD_KEY),
        ),
      },
      {
        name: [LOGOUT_FIELD_KEY],
        value: getPreferenceFromAccount(props.loginStore.account, LOGOUT_FIELD_KEY),
      },
      {
        name: [ENABLE_TWO_FACTOR_AUTH_FIELD_KEY],
        value: JSON.parse(
          getPreferenceFromAccount(props.loginStore.account, ENABLE_TWO_FACTOR_AUTH_FIELD_KEY),
        ),
      },
    ]);
    dispatch(getAllCurrencies());
  }, []);

  const SEARCH_OPTIONS = [
    { value: `${intl.formatMessage({ id: 'hotels' })}`, title: 'search.options.Hotels' },
    { value: `${intl.formatMessage({ id: 'condos.title' })}`, title: 'Condos' },
    // { value: `${intl.formatMessage({ id: 'vacation' })}`, title: 'search.options.Vacations' },
    { value: `${intl.formatMessage({ id: 'Cars' })}`, title: 'search.options.Cars' },
  ];

  const handleChange = (_value: string | string[]) => {
  };

  const onFinish = async () => {
    const preferences: IAccountPreference[] = fields.map((item: FieldData) => ({
      key: item.name[0],
      value: Array.isArray(item.value) ? JSON.stringify(item.value) : item.value,
    }));
    const formData = new FormData();
    props.handlePreferences(account as any, preferences, formData);
    const key = DEFAULT_LANGUAGE_FIELD_KEY;
    const pref = preferences.find(p => p.key === key);
    localStorage.setItem(SELECTED_LANGUAGE_LABEL, `${pref?.value}`);
  };
  return (
    <section className="pt-3">
      <div className="container">
        <div className="row">
          <SideNav />
          <div className="col-lg-8 col-xl-9">
            <div className="card shadow-sm border mb-5">
              <div className="card-header border-bottom">
                <h4 className="card-header-title">
                  <i className="bi bi-sliders2 mx-2"></i><FormattedMessage id="nav.preferences" />
                </h4>
              </div>
              <div className="card-body border-bottom">
                <Spin spinning={loading}>
                  <Form
                    fields={fields}
                    layout="vertical"
                    onFieldsChange={(_, allFields) => {
                      setFields(allFields);
                    }}
                    onFinish={onFinish}
                  >
                    <Card bordered={false} className="border-bottom mb-3 preferencesSec">
                      <Spin spinning={loading}>
                        <Row>
                          <Col md={12}>
                            <div className="h5" style={{ marginBottom: '15px' }}><FormattedMessage id="general" /></div>
                          </Col>

                          <Col md={6}>
                            <Form.Item
                              name={DEFAULT_LANGUAGE_FIELD_KEY}
                              label={intl.formatMessage({ id: 'language' })}
                              rules={[{ required: true, message: `Language is required` }]}
                            >
                              <Select className="customSelect">
                                <Select.Option value="en"><FormattedMessage id="languages.english" /></Select.Option>
                                <Select.Option value="es"><FormattedMessage id="languages.spanish" /></Select.Option>
                              </Select>
                            </Form.Item>
                          </Col>

                          <Col md={6}>
                            <Form.Item
                              name={DEFAULT_CURRENCY_FIELD_KEY}
                              label={intl.formatMessage({ id: 'currency' })}
                              rules={[{ required: true, message: `Currency is required` }]}
                            >
                              {/* <Input type="text" className="form-control form-control-lg" /> */}
                              <Select className="customSelect">
                                {currencies.map((currency:CurrencyData) => (
                                  <Select.Option key={currency.code} value={currency.code}>
                                    {currency.code}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>

                          <Col md={6}>
                            <Form.Item
                              name={EMAIL_SUBJECT_CONFIRMED_FIELD_KEY}
                              label={intl.formatMessage({ id: 'email.subject' })}
                              rules={[{ required: false }]}
                            >
                              <Input type="text" className="form-control form-control-lg" />
                            </Form.Item>
                          </Col>

                          <Col md={6}>
                            <Form.Item
                              name={SEARCH_TYPE_FIELD_KEY}
                              label={intl.formatMessage({ id: 'search.types' })}
                              rules={[{ required: false }]}
                            >
                              <Select
                                mode="multiple"
                                //size={'large'}
                                placeholder="Please select"
                                //defaultValue={['Hotels']}
                                onChange={handleChange}
                                //style={{ width: '100%' }}
                                className="customSelect"
                                options={SEARCH_OPTIONS}
                              />
                            </Form.Item>
                          </Col>

                          <Col md={6}>
                            <Form.Item
                              name={TRAVEL_STATEMENT_DESCRIPTOR_FIELD_KEY}
                              label={intl.formatMessage({ id: 'statement.descriptor' })}
                            >
                              <Input
                                type="text"
                                className="form-control form-control-lg"
                                placeholder="TRAVEL RESERVATION - T.8287854573"
                              />
                            </Form.Item>
                          </Col>
                          <Col md={6}>
                            <Form.Item name={LEAD_TIME_FIELD_KEY} label={intl.formatMessage({ id: 'lead.time' })}>
                              <Input
                                type="text"
                                className="form-control form-control-lg"
                                placeholder="Enter Lead Time"
                              />
                            </Form.Item>
                          </Col>

                          <Col md={6}>
                            <Form.Item
                              name={GOOGLE_ANALITYCS_CODE_FIELD_KEY}
                              label={intl.formatMessage({ id: 'google.analytics.code' })}
                            >
                              <Input
                                type="text"
                                className="form-control form-control-lg"
                                placeholder="Enter Google Analytics Code"
                              />
                            </Form.Item>
                          </Col>
                          <Col md={6}>
                            <Form.Item name={REPLY_EMAIL_FIELD_KEY} label={intl.formatMessage({ id: 'reply.email' })}>
                              <Input
                                type="text"
                                className="form-control form-control-lg"
                                placeholder="Enter Reply Email"
                              />
                            </Form.Item>
                          </Col>
                          <Col md={6}>
                            <Form.Item name={DISPLAY_EMAIL_FIELD_KEY} label={intl.formatMessage({ id: 'display.email' })}>
                              <Input
                                type="text"
                                className="form-control form-control-lg"
                                placeholder="Enter Display Email"
                              />
                            </Form.Item>
                          </Col>

                          <Col md={12}>
                            <div className="h5" style={{ marginBottom: '15px', marginTop: '30px' }}><FormattedMessage id="security" /></div>
                          </Col>

                          <Col md={6}>
                            <Form.Item
                              name={ENABLE_TWO_FACTOR_AUTH_FIELD_KEY}
                              valuePropName="checked"
                              rules={[{ required: false }]}
                            >
                              <Checkbox className="customCheckbox">
                                <FormattedMessage id="twoFA" />
                              </Checkbox>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Spin>
                    </Card>
                    <div className="d-flex justify-content-end">
                      <BlueButton
                        block
                        size="large"
                        type="primary"
                        htmlType="submit"
                        className="btn btn-primary commonBlueBtn"
                        disabled={loading}
                      >
                        <FormattedMessage id="save.changes" />
                      </BlueButton>
                    </div>
                  </Form>
                </Spin>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    loginStore: state.loginStore,
    accountSettingStore: state.accountSettingStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  handlePreferences,
};

const CompanyPreferences = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(CompanyPreferencesComponent));
export default CompanyPreferences;
